import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import LINK from '@/utils/Constants/Link';

import ALink from '@/components/atoms/ALink';

const RegisteredProductBox = ({
  registeredproduct,
  purchasedon,
  registeredon,
  t,
}) => {
  if (!registeredproduct) {
    return null;
  }
  return (
    <>
      <div className='dln-orderRev__wrap dln-orderRev__wrap--registeredproduct'>
        {purchasedon && (
          <span className='dln-orderRev__purchaseDate'>
            {t('form.purchase.date.label')}
            <b> {format(purchasedon, t('format.date1'))}</b>
          </span>
        )}

        {registeredon && (
          <span className='dln-orderRev__purchaseDate'>
            {t('account:account.registered.products.date.registration')}
            <b> {format(registeredon, t('format.date1'))}</b>
          </span>
        )}
      </div>
      <div className='dln-orderRev__wrap dln-orderRev__wrap--links'>
        <ALink
          text={t('account:account.text.customer.support')}
          url={LINK.SUPPORT}
        />
        <ALink text={t('account:account.text.faq')} url={LINK.FAQS} />
      </div>
    </>
  );
};

RegisteredProductBox.propTypes = {
  registeredproduct: PropTypes.bool.isRequired,
  purchasedon: PropTypes.number,
  registeredon: PropTypes.number,
  t: PropTypes.func.isRequired,
};

RegisteredProductBox.defaultProps = {
  purchasedon: null,
  registeredon: null,
};

export default RegisteredProductBox;
